export default __webpack_public_path__ + "static/media/yayin-kuruluslari.eed2bffc.jpg";